import React from 'react';
import PropTypes from 'prop-types';
import Page from 'components/widgets/Route';
import qs from 'qs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlowContainer from './container/FlowContainer';
import * as actions from './actions';
import { fetchSchemas } from '../schema/actions';
import { fetchCredentials } from '../credentials/actions';
import { fetchGroupSummaries } from '../apidocs/actions';
import TriggersList from '../triggers/container/TriggersList';

class FlowsRoute extends React.Component {
	constructor(props) {
		super(props);
		this.fetchFlowData = this.fetchFlowData.bind(this);
		this.fetchNewFlow = this.fetchNewFlow.bind(this);
		this.fetchFlowPrerequisites = this.fetchFlowPrerequisites.bind(this);
		this.useFullscreenLayout = this.useFullscreenLayout.bind(this);
		this.fetchTriggers = this.fetchTriggers.bind(this);
	}

	fetchTriggers() {
		this.props.actions.fetchTriggers();
	}

	fetchFlowPrerequisites() {
		const {
			clearFlowValidation,
			fetchFlowNodeHandlers,
			fetchFlowTriggerDefinitions,
			fetchSchemas,
			fetchGroupSummaries,
			debugFlowClear
		} = this.props.actions;
		clearFlowValidation();
		fetchFlowNodeHandlers();
		fetchFlowTriggerDefinitions();
		fetchSchemas();
		fetchGroupSummaries();
		debugFlowClear();
	}

	fetchFlowData({ match: { params } }) {
		const { fetchFlow } = this.props.actions;
		this.fetchFlowPrerequisites();
		const flowId = decodeURIComponent(params.id);
		// existing flow
		fetchFlow(decodeURIComponent(flowId)); // Why a second decode??
	}

	fetchNewFlow({ location }) {
		const { newEndpointFlow, newUnboundFlow } = this.props.actions;
		this.fetchFlowPrerequisites();
		const query = qs.parse(location.search, { ignoreQueryPrefix: true });
		if (query.friendlyName) {
			newUnboundFlow(query.friendlyName);
		} else {
			newEndpointFlow(query.group, query.method, query.path);
		}
	}

	useFullscreenLayout({ match: { params } }) {
		const flowID = decodeURIComponent(params.id);
		return this.props.flows && this.props.flows[flowID] && !this.props.flows[flowID].error;
	}

	render() {
		const { match: { path } } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					path={path}
					onEnter={this.fetchTriggers}
					component={TriggersList}
				/>
				<Page.Route
					fullscreen={this.useFullscreenLayout}
					path={`${path}/:id/edit`}
					onEnter={this.fetchFlowData}
					component={FlowContainer}
				/>
				<Page.Route
					fullscreen
					path={`${path}/create`}
					onEnter={this.fetchNewFlow}
					component={FlowContainer}
				/>
			</Page>
		);
	}
}

FlowsRoute.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	}).isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		actions: {
			...bindActionCreators(actions, dispatch),
			fetchSchemas: bindActionCreators(fetchSchemas, dispatch),
			fetchCredentials: bindActionCreators(fetchCredentials, dispatch),
			fetchGroupSummaries: bindActionCreators(fetchGroupSummaries, dispatch)
		}
	};
}

function mapStateToProps(state) {
	const flows = state.flows.flows;
	return {
		flows
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FlowsRoute);

